// import config from './config';

const featureToggles = {
  savedJobs: true,
  uploadCV: true,
  creatorPartnership: true,
  // Allow-list of user IDs who always see feature toggles
  featureFlagOverrideUserIds: [2, 341236],
};

export default featureToggles;
